import { Component, OnInit } from '@angular/core';
import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatDividerModule } from '@angular/material/divider';

import { ReportsService } from '../../../domain/services/reports/reports.service';
import { DistributionDetailModel, DistributionStatus, DistributionSubReport } from '../../../domain/models/distribution.model';

@Component({
  selector: 'app-report-detail',
  standalone: true,
  imports: [
    CommonModule,
    CurrencyPipe,
    DatePipe,
    RouterModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatDividerModule,
  ],
  templateUrl: './report-detail.component.html',
  styleUrl: './report-detail.component.css',
})
export class ReportDetailComponent implements OnInit {
  distribution!: DistributionDetailModel;
  displayedColumns = ['name'];
  readonly DistributionStatus = DistributionStatus;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly reportsService: ReportsService
  ) {}

  ngOnInit(): void {
    const id = Number(this.route.snapshot.params['id']);
    if (id) {
      this.reportsService.getDistributionDetail(id).subscribe((data) => {
        this.distribution = data;
      });
    }
  }

  formatPeriod(periodStart: string, periodEnd: string): string {
    const fmt = (d: string) => {
      const [y, m, day] = d.split('-');
      return `${m}/${day}/${y}`;
    };
    return `${fmt(periodStart)} - ${fmt(periodEnd)}`;
  }

  getStatusLabel(status: DistributionStatus): string {
    switch (status) {
      case DistributionStatus.DRAFT:
        return 'In Progress';
      case DistributionStatus.READY:
        return 'Ready';
      case DistributionStatus.APPROVED:
        return 'Approved';
      case DistributionStatus.FINALIZED:
        return 'Complete';
      default:
        return status;
    }
  }

  onViewReport(subReport: DistributionSubReport): void {
    // Placeholder: navigate to printable report view
    console.log('View report:', subReport);
  }
}
